// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"7b86ffc0","256":"8b6b64aa"}[chunkId] + ".chunk.js";
};